module.exports = __webpack_public_path__ + "f99accead7e86c767939d1ea96415c15.glb";